export const aceEditorThemes = ["vs", "vs-dark", "hc-black"];
export const aceEditorFontSize = [12, 14, 16, 22, 28, 36, 48, 72];
